export function truncateText(text?: string) {
  if (!text) return '';
  text = text.trim();

  return text.length > 33 ? `${text.slice(0, 33)}...` : text;
}
